// @view/authentication/EmailValidationBodySuccess.view.tsx

import React from "react";
import * as styles from "@styles/EmailValidation.css";
import { Button } from "@components/ui/button";
import * as Option from "@utils/Option";
import { ok } from "@ps-bridge/ok";
import * as IO from "@ps-bridge/interop/io";
import type { EmailValidationViewProps } from "@ps-bridge/contracts/emailValidation";

type EmailValidationBodySuccessViewProps = Pick<EmailValidationViewProps, "onNavigateToHome">;

const EmailValidationBodySuccessView: React.FC<EmailValidationBodySuccessViewProps> = ({
  onNavigateToHome,
}) => {
  return (
    <>
      <p className={styles.subtitle} data-testid="email-verify-success-message">
        Your email is confirmed. You now have full access.
      </p>
      <Button
        className={styles.primaryButton}
        data-testid="email-verify-go-home"
        onClick={() => IO.run(onNavigateToHome(ok))}
        asChild={Option.none()}
      >
        Take me to the application
      </Button>
    </>
  );
};

export default EmailValidationBodySuccessView;
